import Swiper from "swiper";
import { FreeMode, Mousewheel, Navigation } from "swiper/modules";

const popularTimes = document.getElementById("popular-times");

if (popularTimes) {
  let currentSwiper: HTMLElement | null = null;

  const weekdaySwipers = [
    ...popularTimes.querySelectorAll<HTMLElement>("[data-popular-times-weekday]")
  ];

  if (weekdaySwipers) {
    weekdaySwipers.forEach(weekdaySwiper => {
      const leftButton = weekdaySwiper.querySelector(
        "[data-popular-times-previous]"
      ) as HTMLElement;
      const rightButton = weekdaySwiper.querySelector(
        "[data-popular-times-next]"
      ) as HTMLElement;

      const currentTimeSlide = [
        ...weekdaySwiper.querySelectorAll<HTMLElement>("[data-popular-times-hour]")
      ].findIndex(slide => slide.hasAttribute("data-popular-times-hour-current"));

      new Swiper(weekdaySwiper, {
        modules: [FreeMode, Mousewheel, Navigation],
        breakpoints: {
          1024: {
            enabled: false,
            spaceBetween: 0 // Set to 0 here as we use gap in MD (1024px) instead
          }
        },
        centeredSlides: true,
        centeredSlidesBounds: true,
        direction: "horizontal",
        freeMode: { enabled: true, sticky: true },
        grabCursor: true,
        initialSlide: currentTimeSlide,
        loop: false,
        mousewheel: {
          sensitivity: 2,
          forceToAxis: true
        },
        navigation: {
          nextEl: rightButton,
          prevEl: leftButton
        },
        scrollbar: false,
        slidesPerGroup: 3,
        slidesPerView: "auto",
        spaceBetween: 8
      });

      if (weekdaySwiper.ariaCurrent === "true") {
        currentSwiper = weekdaySwiper;
      }
    });

    const changeDay = (day: number) => {
      const swiperIndex = weekdaySwipers.findIndex(
        swiper => swiper.dataset.popularTimesWeekday === day.toString()
      );

      if (swiperIndex !== -1) {
        const previousSwiper = currentSwiper;
        currentSwiper = weekdaySwipers[swiperIndex];

        if (!currentSwiper) {
          console.warn("No popular times Swiper found with index", swiperIndex);
          return;
        }

        currentSwiper.inert = false;
        currentSwiper.ariaCurrent = "true";

        if (previousSwiper) {
          previousSwiper.inert = true;
          previousSwiper.ariaCurrent = "false";
        }
      } else {
        console.warn("No popular times Swiper found for day", day);
      }
    };

    const weekdayButtons = popularTimes.querySelectorAll<HTMLButtonElement>(
      "[data-popular-times-set-weekday]"
    );

    weekdayButtons.forEach(button => {
      button.addEventListener("click", e => {
        const currentButton = e.currentTarget as HTMLElement;
        const day = parseInt(currentButton.dataset.popularTimesSetWeekday ?? "0");

        if (currentButton.ariaCurrent === "true") {
          return;
        }

        // Reset all weekday button states
        weekdayButtons.forEach(button => (button.ariaCurrent = "false"));

        currentButton.ariaCurrent = "true";

        changeDay(day);
      });
    });
  }
}
